export enum PropertyConstants {
  Container = 'Experiment.Default.Container',
  ConcentrationUnits = 'IngredientStock.ConcentrationUnits',
  StocksDefaultLiquidClass = 'IngredientStock.Default.LiquidClass',
  StocksDefaultDispenseOrder = 'IngredientStock.Default.DispenseOrder',
  HideIrrelevantColumns = 'IngredientStock.HideIrrelevantColumns',
  ScreenExperimentWizardNameDelimiter = 'ScreenExperimentWizard.NameDelimiter',
  ScreenExperimentWizardDateTimeFormat = 'ScreenExperimentWizard.DateTimeFormat',
  ScoreWithoutImages = 'Scores.Score.ScoreWithoutImages',
  AllowEditingOfReadonlyExperiment = 'Experiment.AllowEditingOfReadonlyExperiment',
  ExplorerSidePanelOpen = 'Experiment.Default.ExplorerSidePanelOpen',
  SeachFilterEnableCanvas = 'SearchFilter.EnableCanvas',
  SearchFilterPageSize = 'SearchFilter.PageSize',
  DefaultCrystalName = 'Project.Default.CrystalName',
  ShowIngredientLongName = 'Ingredient.ShowLongName',
  IngredientPickerShowToolTip = 'IngredientSelector.ShowToolTip',
  IngredientPickerShowStockPrepared = 'IngredientSelector.ShowStockPrepared',
  AllowDisputedScoreDrawing = 'Scores.AllowDisputedScoreDrawing',
  ExcludeIgnoredScoresFromHitCounts = 'Scores.ExcludeIgnoredScoresFromHitCounts',
  ExperimentNavigatorVisible = 'Experiment.Navigator.ExperimentNavigator.Visible',
  SlideShowChangeInterval = 'SlideShow.SlideChangeInterval',
  RestartScoringOnceDone = 'Imaging.PlateViewer.RestartScoringOnceDone',
  DropImageVerticalPrefetchingCount = 'Drop.Imaging.Prefetching.Vertical',
  DropImageHorizontalPrefetchingCount = 'Drop.Imaging.Prefetching.Horizontal',
  DropImagingCacheMaxSizeMB = 'Drop.Imaging.Cache.MaxSizeMB',
  DropImagingFocusLevelCacheEnabled = 'Drop.Imaging.Cache.FocusLevelEnabled',
  CanvasNavigatorPrefetchingVertical = 'Canvas.Navigator.Prefetching.Vertical',
  CanvasNavigatorPrefetchingHorizontal = 'Canvas.Navigator.Prefetching.Horizontal',
  DefaultCompareMode = 'Experiment.Default.CompareMode',
  DefaultExplorerView = 'Tree.DefaultExplorerView',
  DefaultSidePanel = 'Experiment.Default.SidePanel',
  DropInfoTopBarSticky = 'Drop.Imaging.InfoTopBar.Sticky',
  ArchivingStartTime = 'Archiving.StartTime',
  GridOptimizeWellsIntoGrids = 'Optimization.GridExperiment.GridWells',
  GridOptimizationScoreGroupName = 'Optimization.Scores.GroupName',
  GridOptimizationStartName = 'Optimization.Scores.StartName',
  GridOptimizationStopName = 'Optimization.Scores.StopName',
  GridOptimizationStartNearName = 'Optimization.Scores.StartNearName',
  GridOptimizationStopNearName = 'Optimization.Scores.StopNearName',
  GridOptimizationMaxNumRows = 'Optimization.Scores.MaxNumRows',
  GridOptimizationMaxNumColumns = 'Optimization.Scores.MaxNumColumns',
  EnableDropsByDefault = 'Container.EnableDropsByDefault',
  ProteinFormulationShowAPIData = 'ProteinFormulation.ShowAPIData',
  ProteinFormulationAPIDataLabel = 'ProteinFormulation.APIDataLabel',
  ProteinImportType = 'Importing.Protein.Type',
  SearchFilterEnableCustomRounding = 'SearchFilter.EnableCustomRounding',
  SearchFilterSignificantDigitsAfterDecimal = 'SearchFilter.SignificantDigitsAfterDecimal',
}
